import { v4 as uuidv4 } from 'uuid';

import { AbsenceEntry, AbsenceType } from '~/data/absences/types';
import {
  AbsenceDataRow,
  AbsenceTableRowCommon,
} from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/data/types';

export * from './types';

export const getAbsenceDataRowCommonFromAbsenceEntry = (
  entry: AbsenceEntry,
): AbsenceTableRowCommon => {
  const {
    uid,
    reason,
    startDate,
    endDate,
    info,
    attachment,
    status,
    supersededReason,
  } = entry;

  const commonEntryData = {
    id: uid ?? uuidv4(),
    reason: reason?.name ?? '',
    year: '',
    startDate,
    endDate,
    days: 0,
    hours: '',
    plannedWorkingHours: '',
    info: info ?? '',
    attachment: attachment?.name ?? '',
    status: supersededReason === 'DELETE' ? supersededReason : status,
    approval: '',
    meta: entry,
  };

  const resolveTypeEntryData = (
    entry: AbsenceEntry,
  ): Pick<
    AbsenceDataRow,
    'days' | 'hours' | 'plannedWorkingHours' | 'year'
  > => {
    if (entry.type === AbsenceType.SHORT) {
      const { days, hours, year, plannedWorkingHours } = entry;
      return {
        days: days ?? 0,
        hours: hours ?? 0,
        plannedWorkingHours: plannedWorkingHours ?? 0,
        year: year ?? 0,
      };
    }

    return {
      days: 0,
      hours: 0,
      plannedWorkingHours: 0,
      year: 0,
    };
  };

  return {
    ...commonEntryData,
    ...resolveTypeEntryData(entry),
  };
};
